import {Captions, ICaption, ITranscript} from '../model/captionModels';
import TimeFormatter from '../util/TimeFormatter';

export const generateTranscriptFromCaptions = (captions: Captions): ITranscript => {
   if (!captions || captions.length === 0) {
      return null;
   }
   const transcript: ITranscript = {};
   captions.forEach((caption: ICaption) => {
      const displayTime = TimeFormatter.millisecondsToFormattedTimeString(caption.startTime);
      const duration = Math.ceil(caption.duration / 1000);
      const text = caption.plainText;
      const key = Math.round(caption.startTime / 1000).toString();
      if (key && displayTime && duration && text) {
         transcript[key] = {
            duration: duration,
            displayTime: displayTime,
            text: text
         };
      }
   });
   return transcript;
};
